import { createContext, useState, useEffect, useContext } from "react";
import FilterService from "../services/FilterService";
import { AuthContext } from "./AuthContext";

export const FiltersContext = createContext(null);

export const FiltersProvider = ({ children }) => {
  const { dataScopeOrgId } = useContext(AuthContext);
  const [inspectionFilters, setInspectionFilters] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchFilters = async () => {
    if (!dataScopeOrgId) return;
    setLoading(true);
    try {
      const { inspectionFilters } = await FilterService.getFilters(
        dataScopeOrgId
      );
      setInspectionFilters(inspectionFilters);
    } catch (error) {
      console.error("Error fetching filters:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFilters();
  }, [dataScopeOrgId]);

  const updateInspectionFilters = async (updatedFilters, silent = false) => {
    try {
      const { inspectionFilters: newInspectionFilters } =
        await FilterService.updateFilters(
          dataScopeOrgId,
          updatedFilters,
          silent
        );
      setInspectionFilters(newInspectionFilters);
    } catch (error) {
      console.error("Error updating inspection filters:", error);
    }
  };

  return (
    <FiltersContext.Provider
      value={{
        inspectionFilters,
        loading,
        setInspectionFilters,
        updateInspectionFilters,
        fetchFilters,
      }}
    >
      {children}
    </FiltersContext.Provider>
  );
};
